import { useEffect, useRef, useState } from 'react';
export const checkinJobCount = (reminders) => reminders.reduce((total, reminder) => total + reminder.jobs.length, 0);
export const sortedCheckinJobs = (reminder) => [...reminder.jobs].sort((a, b) => a.check_in.padStart(5, '0').localeCompare(b.check_in.padStart(5, '0')) || a.job_id - b.job_id);
export function useCheckinReminders(api, enabled, scope = 'active', revision = 0, workgroup = '') {
    const [reminders, setReminders] = useState([]), [error, setError] = useState(''), [loading, setLoading] = useState(false);
    const lastScope = useRef('');
    useEffect(() => {
        if (!enabled) {
            setReminders([]);
            setError('');
            setLoading(false);
            return;
        }
        const key = `${scope}:${workgroup}`;
        if (lastScope.current !== key) {
            setReminders([]);
            lastScope.current = key;
        }
        const abort = new AbortController();
        let busy = false;
        const read = () => {
            if (busy || document.visibilityState !== 'visible')
                return;
            busy = true;
            setLoading(true);
            const params = new URLSearchParams({ scope });
            if (workgroup)
                params.set('workgroup_id', workgroup);
            void api(`/checkin-reminders?${params}`, 'GET', undefined, abort.signal)
                .then(result => { if (!abort.signal.aborted) {
                setReminders(result.reminders);
                setError('');
            } })
                .catch(e => { if (!abort.signal.aborted)
                setError(e instanceof Error ? e.message : 'Unable to load reminders'); })
                .finally(() => { busy = false; if (!abort.signal.aborted)
                setLoading(false); });
        };
        read();
        const timer = setInterval(read, 60000);
        document.addEventListener('visibilitychange', read);
        return () => { abort.abort(); clearInterval(timer); document.removeEventListener('visibilitychange', read); };
    }, [api, enabled, scope, revision, workgroup]);
    return { reminders, error, loading };
}
